var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c("div", { staticClass: "form-network form-network-google" }, [
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(_vm._s(_vm.$t("dash.post-creator.form.link-preview")) + " "),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c("div", { staticClass: "content-detail form-link" }, [
            _c(
              "div",
              { staticClass: "list-thubmmail" },
              _vm._l(
                _vm.draftInstance.form.urlsTextContentHistory,
                function (url) {
                  return _c(
                    "div",
                    {
                      key: url,
                      staticClass: "thubmmail",
                      on: { click: () => _vm.selectUrl(url.value) },
                    },
                    [
                      _c("Checkbox", {
                        attrs: {
                          id: url.value,
                          prefixId: "thubmmail-",
                          isChecked:
                            _vm.draftInstance.form.networks.google.snippet
                              .link == url.value,
                          isDisable:
                            _vm.draftInstance.form.networks.google.snippet
                              .link == url.value,
                          add: () => _vm.selectUrl(url.value),
                          remove: () => {},
                        },
                      }),
                      _c("SnippetNetwork", {
                        attrs: {
                          link: url,
                          imageUrlDefault:
                            !_vm.inputModel.switchCustomSnippet ||
                            _vm.inputModel.titleSnippet ||
                            _vm.inputModel.descriptionSnippet
                              ? undefined
                              : _vm.inputModel.urlImageSnippet,
                          titleDefault: _vm.inputModel.switchCustomSnippet
                            ? _vm.inputModel.titleSnippet
                            : undefined,
                          descriptionDefault: _vm.inputModel.switchCustomSnippet
                            ? _vm.inputModel.descriptionSnippet
                            : undefined,
                        },
                      }),
                    ],
                    1
                  )
                }
              ),
              0
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }